import styled from "styled-components"

import { ReactComponent as IconArrowSmallUp } from "assets/svg/icon-arrow-small-up.svg"

export const WidgetWrapper = styled.div`
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 0 32px 20px;
  flex: 1 1 calc(50% - 10px);
  max-width: calc(50% - 10px);
  min-width: 0;
  min-height: 173px;
  position: relative;

  @media only screen and (max-width: 900px) {
    flex: 1 1 100%;
    max-width: 100%;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const WidgetHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid #f1f5f9;

  .static-select__control {
    min-width: 150px;
    display: flex;
    min-height: 32px !important;
  }
`

export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Title = styled.h3`
  font-family: Inter, sans-serif;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
`

export const ContentWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`

export const DataColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`

export const StatsRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
`

export const ActiveCustomersValue = styled.span`
  font-size: 24px;
  font-weight: 500;
  color: #0f172a;
`

export const ActiveCustomersLabel = styled.span`
  font-size: 12px;
  color: #64748b;
`

export const PercentageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
`

export const PercentageValue = styled.span<{ isPositive: boolean; isZero: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ isPositive, isZero }) => {
    if (isZero) return "#94a3b8"
    return isPositive ? "#22C55E" : "#EF4444"
  }};
`

export const StyledArrowIcon = styled(IconArrowSmallUp)<{ isPositive: boolean }>`
  width: 16px;
  height: 16px;
  transform: ${({ isPositive }) => (isPositive ? "rotate(0deg)" : "rotate(180deg)")};

  path {
    fill: ${({ isPositive }) => (isPositive ? "#22C55E" : "#EF4444")};
  }
`

export const DaysText = styled.span`
  font-size: 12px;
  color: #64748b;
`

export const ChartContainer = styled.div`
  height: 80px;
  min-width: 300px;
  position: relative;
  flex-shrink: 0;
  flex: 1;
`
